import { createFileRoute } from '@tanstack/react-router';
import { ActiveProcessesCard } from './-components/ActiveProcessesCard';
import { ActiveTasksCard } from './-components/ActiveTasksCard';

export const Route = createFileRoute('/_auth/dashboard/_layout/workflows')({
  component: RouteComponent,
  context: () => {
    return {
      getBreadcrumbData: () => ({
        id: null,
        translationKey: null,
      }),
    };
  },
  head: () => {
    return {
      meta: [
        {
          title: 'Dashboard - OPAZ E-Service Portal',
        },
      ],
    };
  },
});

function RouteComponent() {
  return (
    <div className="flex flex-col gap-6">
      <ActiveProcessesCard />
      <ActiveTasksCard />
    </div>
  );
}
